'use client';

import { useTranslation } from 'next-i18next';

/**
 * @description Offer Page Infobox
 */
export const OfferPageInfobox = () => {
  const { t } = useTranslation('common');

  return (
    <div className="mb-10 grid grid-cols-3 gap-5 bg-transparent">
      <div className="text-center">
        <span className="block text-8xl font-thin uppercase">5M</span>
        <h3>{t('offer.page.infobox.title.1')}</h3>
      </div>

      <div className="text-center">
        <span className="block text-8xl font-thin uppercase">5K</span>
        <h3>{t('offer.page.infobox.title.2')}</h3>
      </div>

      <div className="text-center">
        <span className="block text-8xl font-thin uppercase">50K</span>
        <h3>{t('offer.page.infobox.title.3')}</h3>
      </div>

    </div>
  );
};
